/* eslint-disable import/no-anonymous-default-export */
export default {
  translations: { // Mesmo valor usado nas configurações (defaultNS)
    home: {
      message: 'Olá Mundo!'
    },
    //General
    Saved: {//ATENÇÃO, ISSO PODE SER MELHORADO
      Flow: 'Saved flow!',
      Step: 'Saved step!',
      Report: 'Saved report!'
    },
    Fullname: 'Full name',

    AlertDialog: {
      Title: 'Are you sure?',
      Delete: { //ATENÇÃO, ISSO PODE SER MELHORADO
        Flow: 'Do you really want to delete this Flow? This process cannot be undone',
        Step: 'Do you really want to delete this Step? This process cannot be undone',
        Report: 'Do you really want to delete this Report? This process cannot be undone',
      }
    },
    CreatedAt: 'Created At',
    UpdatedAt: 'Updated At',
    Date: {
      Start: 'Start Date',
      End: 'End Date'
    },
    AutoRefresh: 'Auto Refresh',
    Add: {
      Default: 'Add',
      Filter: 'Add Filter'
    },
    Created: {
      Default: 'Created',
      At: 'Created At',
    },
    Updated: {
      Default: 'Updated',
      At: 'Updated At',
    },


    //Steps
    Step: {
      Type: 'Type',
      Code: 'Code',
      DefaultActionCode: 'Default next action code',
      PersistData: 'Persist data?',
      Edit: 'edit',
      Excluded: 'Excluded step',
      ErrorMessage: 'Error message',
    },

    MultipleChoice: 'Multiple Choice',
    NationalId: 'National Id',
    MinLength: 'Minimum length',
    MaxLength: 'Maximum length',
    Multiline: 'Multiline?',
    AllowMultiple: 'Allow multiple?',
    ValidValues: 'Valid values',
    GoTo: 'Go to',
    StayOk: 'Stay here after an ok',
    StayError: 'Stay here after an error',


    //Login
    SignIn: 'Sign In',
    SignUp: "Don't have an account? Sign Up",
    RememberMe: 'Remember me',
    ForgotPassword: 'Forgot password?',
    EnterEmail: "Enter your email to recover your password",
    EnterPassword: "Enter your new password.",

    //Reports
    ReportsQuantity_zero: "None record found",
    ReportsQuantity_one: "{{count}} record found",
    ReportsQuantity_other: "{{count}} records found",
  },
}
